import { useCallback, useState } from 'react';
import Tiptap, { TiptapEditor, ToolbarSize } from '../../molecules/tiptap/Tiptap';
import { Separator } from '@radix-ui/react-separator';
import { TooltipProvider } from '../../molecules/tooltips/tooltip/Tooltip';

export type ImageUploadFieldProps = {
  htmlFieldId: string;
  jsonFieldId: string;
  onValueChange: (value: { html: string; json: string }) => void;
};

export function TiptapEditorField({
  htmlFieldId,
  jsonFieldId,
  onValueChange,
}: ImageUploadFieldProps) {
  const [editor, setEditor] = useState<TiptapEditor | undefined>(undefined);
  const [editorContentHtml, setEditorContentHtml] = useState('');
  const [editorContentJson, setEditorContentJson] = useState('');

  const handleEditorChange = useCallback(
    ({ editor }: { editor: TiptapEditor }) => {
      setEditor(editor);
      const html = editor.getHTML();
      const json = JSON.stringify(editor.getJSON());

      setEditorContentHtml(html);
      setEditorContentJson(json);

      onValueChange({ html, json });
    },
    [onValueChange],
  );

  return (
    <TooltipProvider>
      <input id={htmlFieldId} type="hidden" value={editorContentHtml} />
      <input id={jsonFieldId} type="hidden" value={editorContentJson} />

      <Tiptap.Root
        content={editor?.getJSON()}
        autofocus={true}
        onUpdate={handleEditorChange}
        className="h-[250px] gap-2 rounded-xl border border-neutral-300 bg-white p-3"
      >
        <Tiptap.HtmlRenderer className="min-h-0 flex-1">
          <Tiptap.Content className="border-0 p-0 [&>div]:overflow-auto" />
        </Tiptap.HtmlRenderer>

        <Separator className="bg-neutral-200" />

        <Tiptap.Toolbar size={ToolbarSize.SMALL}>
          <Tiptap.Toolbar.Group>
            <Tiptap.Toolbar.Bold />
            <Tiptap.Toolbar.Italic />
            <Tiptap.Toolbar.Underline />
            <Tiptap.Toolbar.Strike />
          </Tiptap.Toolbar.Group>

          <Tiptap.Toolbar.ListGroup />

          <Tiptap.Toolbar.Group>
            <Tiptap.Toolbar.Link />
          </Tiptap.Toolbar.Group>
        </Tiptap.Toolbar>
      </Tiptap.Root>
    </TooltipProvider>
  );
}
